import { getBaseApiUrl } from "./apiendpoint.utils";

export async function loginUser(loginData) {
    const BASE_API_URL = await getBaseApiUrl();
    const response = await fetch(`${BASE_API_URL}/api/Login_Api`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(loginData),
    });

    if (!response.ok) {
        throw new Error("Incorrect Email or Password");
    }

    return response.json();
}

export async function createOrEditAdmin(adminData) {
    const BASE_API_URL = await getBaseApiUrl();
    const response = await fetch(`${BASE_API_URL}/api/CreateOrEditAdmin`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(adminData),
    });

    if (!response.ok) {
        throw new Error("Failed to Admin Data");
    }

    return response.json();
}

export async function fetchAdmins() {
  const BASE_API_URL = await getBaseApiUrl();

  const response = await fetch(
    `${BASE_API_URL}/api/GetAdmin`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
      requestId: "", // 👈 from component
    }),
    }
  );

  if (!response.ok) {
    throw new Error("Failed to fetch admins");
  }

  return response.json();
}

export async function fetchCourses() {
    const BASE_API_URL = await getBaseApiUrl();

    const response = await fetch(`${BASE_API_URL}/Api/GetCourseByid`);
    if (!response.ok) {
        throw new Error("Failed to fetch courses");
    }

    return response.json();
}

export async function createOrEditCourse(courseData) {
    const BASE_API_URL = await getBaseApiUrl();

    const response = await fetch(`${BASE_API_URL}/Api/AddorEditCourse`, {
        method: "POST",
        body: courseData,
        // headers: {
        //     "Content-Type": "application/json",
        // },
        // body: JSON.stringify(courseData),
    });

    if (!response.ok) {
        throw new Error("Failed to create course");
    }

    return response.json();
}


export async function deleteCourse(courseId) {
    const BASE_API_URL = await getBaseApiUrl();
    const formData = new FormData();
    formData.append("CourseId", courseId);
    formData.append("IsDelete", "true");

    const response = await fetch(`${BASE_API_URL}/Api/DeleteCourse`, {
        method: "delete",
        body: formData,

    });
    if (!response.ok) {
        throw new Error("Failed to delete course");
    }
    return response.json();
}

export async function addOrEditPricing(priceData) {
    const BASE_API_URL = await getBaseApiUrl();
    const response = await fetch(`${BASE_API_URL}/Api/AddorEditPricing`, {
        method: "post",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(priceData),
    });
    const data = await response.json();
    if (!response.ok) {
        throw new Error(data?.message || "Failed to Add or Edit Pricing Plan");
    }
    return data;
}

export async function fetchPricingPlan() {
    const BASE_API_URL = await getBaseApiUrl();

    const response = await fetch(`${BASE_API_URL}/Api/GetPricing`);

    if (!response.ok) {
        throw new Error("Failed to fetch Pricing plan");
    }

    return response.json();
}

export async function changePassword(passwordData) {
    const BASE_API_URL = await getBaseApiUrl();

    const response = await fetch(`${BASE_API_URL}/api/ChangePassword`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(passwordData),
    });

    if (!response.ok) {
        throw new Error("Failed to change password");
    }
    return response.json();
}

export async function contactUs(payload) {
    const BASE_API_URL = await getBaseApiUrl('enquiry');

    const response = await fetch(`${BASE_API_URL}`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            entity: "wellspoken",
        },
        body: JSON.stringify(payload),
    });

    if (!response.ok) {
        throw new Error("Form submission failed");
    }
    return response.json();
}